import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../base/base.component';

declare var bootbox:any;

@Component({
  selector: 'undefined-demo-users',
  template: require('./demo-users.component.html'),
  styles: [require('./demo-users.component.css')]
})
export class DemoUsersComponent extends BaseComponent implements OnInit {


  public dusers = [];

  ngOnInit() {
    this.loadDemoUsers();
  }

  public loadDemoUsers() {
    this.busy = this.lsApi.getDemoUsers().subscribe(resp => {
        if(resp.status) {
            this.dusers = resp.data;
            //this.router.navigate([this.router.url]);
        }
    },
    error => {
        console.log(error);
    });
  }

  public downloadDemoReport() {
    this.busy = this.lsApi.downloadDemoUsers().subscribe(resp => {
      if(resp.status) {
          window.location.href = "/resources/demo/report/" + this.lsApp.getCurrentAuthToken() + "/" + resp.data[0] + "/";
      }
  },
  error => {
      console.log(error);
  });
  }

  


}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/demo-users/demo-users.component.ts